export default __webpack_public_path__ + "static/media/left_ins.c059e731.svg";